import { Box, Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';
import ActiveIcon from '@/assets/icons/active-icon.svg?react';
import ErrorIcon from '@/assets/icons/error-icon.svg?react';
import ServiceAddIcon from '@/assets/icons/service-add-icon.svg?react';
import { bagStatuses } from '@/constants/Bag';
import WarningIcon from '@/assets/icons/warning-icon.svg?react';

const statusBoxStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: 3,
    width: 'max-content',
};

const StatusIconWithInfo = ({ icon, statusInfo }) => {
    if (!statusInfo) {
        return icon;
    }

    return (
        <Tooltip title={<Typography sx={{ whiteSpace: 'pre-line', fontSize: '11px', lineHeight: '16px' }}>{statusInfo}</Typography>}>
            <Box tabIndex={0}>{icon}</Box>
        </Tooltip>
    );
};

StatusIconWithInfo.propTypes = {
    icon: PropTypes.element.isRequired,
    statusInfo: PropTypes.string,
};

export const StatusField = ({ record }) => {
    const translate = useTranslate();
    if (!record) return null;

    if (record.status === bagStatuses.collected) {
        return (
            <Box {...statusBoxStyles}>
                <StatusIconWithInfo icon={<ActiveIcon />} statusInfo={record.statusInfo} />
                <Typography variant='body2'>{translate('resources.bag.labels.closedBag')}</Typography>
            </Box>
        );
    }

    if (record.status === bagStatuses.in_progress) {
        return (
            <Box {...statusBoxStyles}>
                <ServiceAddIcon />
                <Typography variant='body2'>{translate('resources.bag.labels.fillingInProgress')}</Typography>
            </Box>
        );
    }
    if (record.status === bagStatuses.manually_closed) {
        return (
            <Box {...statusBoxStyles}>
                <WarningIcon />
                <Typography variant='body2'>{translate('resources.bag.labels.manuallyClosed')}</Typography>
            </Box>
        );
    }

    if (record.status === bagStatuses.error) {
        return (
            <Box {...statusBoxStyles}>
                <StatusIconWithInfo icon={<ErrorIcon />} statusInfo={record.statusInfo} />
                <Typography variant='body2'>{translate('resources.bag.labels.error')}</Typography>
            </Box>
        );
    }

    return record.status || '—';
};

StatusField.propTypes = {
    record: PropTypes.shape({
        status: PropTypes.string,
        statusInfo: PropTypes.string,
    }),
};
